import PropTypes from 'prop-types';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';
import { getLabelMessage } from '@gef-ui/localization/messages';

import Sidebar from 'components/atoms/GefMui/Sidebar/Sidebar';
import SidebarSection from 'components/atoms/GefMui/SidebarSection';
import { MPU_DISPLAY_TASK_DETAIL } from 'features/common/acl/constants';

import SidebarClientInfo from './SidebarClientInfo';
import SidebarPolicyInfo from './SidebarPolicyInfo';

export const DetailSidebar = () => (
	<Sidebar>
		<AccessControl accessLevel={MPU_DISPLAY_TASK_DETAIL}>
			<Sidebar.Body spacing={2} sx={{ p: 3, maxHeight: 'unset !important' }}>
				<SidebarSection heading={getLabelMessage('detail:asideBarMainHeader')}>
					<SidebarPolicyInfo />
				</SidebarSection>
				<SidebarSection heading={getLabelMessage('detail:asideBarMainSecondHeader')}>
					<SidebarClientInfo />
				</SidebarSection>
			</Sidebar.Body>
		</AccessControl>
	</Sidebar>
);

DetailSidebar.propTypes = {
	taskId: PropTypes.string,
};

export default DetailSidebar;
